// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".binding-information[data-v-39d77a9a]{display:flex;gap:4px;align-items:center}.binding-information .avatar-icon[data-v-39d77a9a]{border-radius:100px}", ""]);
// Exports
module.exports = exports;
